import axios from "axios";

function forceFileDownload(response, title) {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", title);
  document.body.appendChild(link);
  link.click();
}

export function fileDownload(url, title) {
  const ext = url.split(".").pop();
  axios({
    method: "get",
    url,
    responseType: "arraybuffer",
  })
    .then((response) => {
      forceFileDownload(response, `${title}.${ext}`);
    })
    .catch(() => console.log("Erro ao baixar arquivo!"));
}
